<template>

  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Plan de Explotación</p>
              <argon-button color="success" size="sm" class="ms-auto" @click="save">Guardar</argon-button>
            </div>
          </div>
          <div class="card-body">

            <!-- Tabs de navegación -->
            <ul class="nav nav-tabs" id="consultationTabs" role="tablist" v-if="extraction.id != 0">

              <!-- Tab de Datos de la Explotación -->
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="exploitation-tab" data-bs-toggle="tab"
                  data-bs-target="#exploitation" type="button" role="tab" aria-controls="exploitation"
                  aria-selected="true">
                  Plan de Explotación
                </button>
              </li>

              <!-- Tab de Transporte -->
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="transport-tab" data-bs-toggle="tab" data-bs-target="#transport"
                  type="button" role="tab" aria-controls="transport" aria-selected="false">
                  Transporte
                </button>
              </li>

              <!-- Tab de Almacenamiento -->
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="storage-tab" data-bs-toggle="tab" data-bs-target="#storage" type="button"
                  role="tab" aria-controls="storage" aria-selected="false">
                  Almacenamiento
                </button>
              </li>
            </ul>

            <!-- Contenido de los tabs -->
            <div class="tab-content" id="consultationTabsContent">

              <!-- Tab 1: Datos de la Extracción -->
              <div class="tab-pane fade show active" id="exploitation" role="tabpanel"
                aria-labelledby="exploitation-tab">
                <div class="p-3">
                  <p class="text-uppercase text-sm">Información de la Explotación</p>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-control-label">Mina</label>
                      <!-- Se añade v-model para capturar la mina seleccionada -->
                      <select class="form-control" v-model="extraction.mine_id">
                        <option disabled value="">Seleccione una mina</option>
                        <option v-for="mine in mines" :key="mine.id" :value="mine.id">
                          {{ mine.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">Ubicación de la Mina</label>
                      <argon-input type="text" v-model="extraction.extraction_location" :disabled="true"
                        placeholder="Seleccione una mina primero" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">Fecha de Extracción</label>
                      <argon-input type="date" v-model="extraction.extraction_date" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">Cantidad Extraída (Tn)</label>
                      <argon-input type="number" step="0.01" v-model="extraction.extracted_quantity" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">Equipos Utilizados</label>
                      <argon-input type="text" v-model="extraction.equipment_used" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">Trabajador</label>
                      <select ref="selectUser" class="form-control" v-model="extraction.worker_id">
                        <option value="" disabled>Seleccione un usuario</option>
                        <option v-for="user in users" :key="user.id" :value="user.id">
                          {{ user.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">Calidad de la Arcilla</label>
                      <argon-input type="text" v-model="extraction.quality_grade" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label">Porcentaje de Humedad</label>
                      <argon-input type="number" step="0.01" v-model="extraction.moisture_content" />
                    </div>
                    <div class="col-md-12">
                      <label class="form-control-label">Notas Adicionales</label>
                      <textarea class="form-control" rows="3" v-model="extraction.notes"></textarea>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tab 2: Datos de Transporte -->
              <div class="tab-pane fade" id="transport" role="tabpanel" aria-labelledby="transport-tab">
                <div class="p-3">
                  <p class="text-uppercase text-sm">Información de Transporte</p>

                  <!-- Tabla de Transportes -->
                  <div class="card-body px-0 pt-0 pb-2 mt-3">
                    <div class="table-responsive p-0">
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Fecha de Transporte
                            </th>
                            <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Placa del Vehículo
                            </th>
                            <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Nombre del Conductor
                            </th>
                            <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Costo del Transporte
                            </th>
                            <th class="text-secondary text-center">
                              <!-- Enlace para crear registro en nueva vista -->
                              <router-link :to="{
                                name: 'Extraction Transport',
                                params: {
                                  data: JSON.stringify({
                                    mines_extractions_id: extraction.id
                                  })
                                }
                              }" class="text-secondary font-weight-bold text-xs">
                                Agregar <i class="fa fa-plus"></i>
                              </router-link>

                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="t in transports" :key="t.id">
                            <!-- Fecha de Transporte -->
                            <td class="align-middle text-center">
                              <span class="text-secondary text-xs font-weight-bold">
                                {{ new Date(t.transport_date).toLocaleDateString('es-ES') }}
                              </span>
                            </td>
                            <!-- Placa del Vehículo -->
                            <td class="align-middle text-center text-sm">
                              {{ t.vehicle }}
                            </td>
                            <!-- Nombre del Conductor -->
                            <td class="align-middle text-center text-sm">
                              {{ t.driver_name }}
                            </td>
                            <!-- Costo del Transporte -->
                            <td class="align-middle text-center text-sm">
                              {{ t.transport_cost }}
                            </td>
                            <!-- Acciones (Editar / Eliminar) -->
                            <td class="align-middle text-center">
                              <!-- Enlace para editar -->
                              <router-link :to="{
                                name: 'Extraction Transport',
                                params: { data: JSON.stringify(t) }
                              }" class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                                data-original-title="Editar transporte">
                                <i class="fa fa-pencil-alt"></i>
                              </router-link>

                              <a @click="deleteTransport(t.id)"
                                class="text-secondary font-weight-bold text-xs cursor-pointer"
                                style="margin-left: 15px;" data-toggle="tooltip"
                                data-original-title="Eliminar transporte">
                                <i class="fa fa-trash"></i>
                              </a>
                            </td>
                          </tr>
                          <tr v-if="transports.length === 0">
                            <td colspan="5" class="text-center text-xxs">
                              No hay registros disponibles
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tab 3: Datos de Almacenamiento -->
              <div class="tab-pane fade" id="storage" role="tabpanel" aria-labelledby="storage-tab">
                <div class="p-3">
                  <p class="text-uppercase text-sm">Información de Almacenamiento</p>

                  <!-- Tabla de Almacenamiento -->
                  <div class="card-body px-0 pt-0 pb-2 mt-3">
                    <div class="table-responsive p-0">
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Fecha del Producto
                            </th>
                            <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Cantidad Final
                            </th>
                            <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Calidad del Producto
                            </th>
                            <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Ubicación del Almacenamiento
                            </th>
                            <th class="text-secondary text-center">
                              <!-- Enlace para crear registro en nueva vista -->
                              <router-link :to="{
                                name: 'Extraction Final',
                                params: {
                                  data: JSON.stringify({
                                    mines_extractions_id: extraction.id
                                  })
                                }
                              }" class="text-secondary font-weight-bold text-xs">
                                Agregar <i class="fa fa-plus"></i>
                              </router-link>

                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="fin in final" :key="fin.id">
                            <!-- Fecha del Producto -->
                            <td class="align-middle text-center">
                              <span class="text-secondary text-xs font-weight-bold">
                                {{ new Date(fin.product_date).toLocaleDateString('es-ES') }}
                              </span>
                            </td>
                            <!-- Cantidad Final -->
                            <td class="align-middle text-center text-sm">
                              {{ fin.final_quantity }}
                            </td>
                            <!-- Calidad del Producto -->
                            <td class="align-middle text-center text-sm">
                              {{ fin.product_quality }}
                            </td>
                            <!-- Ubicación del Almacenamiento -->
                            <td class="align-middle text-center text-sm">
                              {{ fin.storage_location }}
                            </td>
                            <!-- Acciones (Editar / Eliminar) -->
                            <td class="align-middle text-center">
                              <!-- Enlace para editar -->
                              <router-link :to="{
                                name: 'Extraction Final',
                                params: { data: JSON.stringify(fin) }
                              }" class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                                data-original-title="Editar almacenamiento">
                                <i class="fa fa-pencil-alt"></i>
                              </router-link>

                              <a @click="deleteFinal(fin.id)"
                                class="text-secondary font-weight-bold text-xs cursor-pointer"
                                style="margin-left: 15px;" data-toggle="tooltip"
                                data-original-title="Eliminar almacenamiento">
                                <i class="fa fa-trash"></i>
                              </a>
                            </td>
                          </tr>
                          <tr v-if="final.length === 0">
                            <td colspan="5" class="text-center text-xxs">
                              No hay registros disponibles
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>


            </div>

            <!-- Botones de navegación -->
            <div class="d-flex justify-content-between mt-4" v-if="extraction.id != 0">
              <argon-button color="secondary" size="sm" id="prevBtn" @click="navigateTabs('prev')"
                :disabled="activeTabIndex === 0">
                Anterior
              </argon-button>
              <argon-button color="primary" size="sm" id="nextBtn" @click="navigateTabs('next')"
                :disabled="activeTabIndex === 5">
                Siguiente
              </argon-button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.min.css';
import 'select2';


const body = document.getElementsByTagName("body")[0];


export default {
  name: "User Create",
  data() {
    return {
      showMenu: false,
      activeTabIndex: 0,
      extraction: {
        id: 0,
        mine_id: '',
        extraction_date: '',
        extracted_quantity: 0,
        extraction_location: '',
        equipment_used: '',
        worker_id: '',
        quality_grade: '',
        moisture_content: 0,
        notes: ''
      },
      transport: {
        mines_extractions_id: null,
        transport_date: '',
        vehicle: '',
        driver_name: '',
        transport_cost: ''
      },
      fin: {
        mines_extractions_id: null,
        product_date: '',
        final_quantity: 0,
        product_quality: '',
        storage_location: ''
      },
      production: {
        mines_extractions_id: null,
        product_date: "",
        final_quantity: null,
        product_quality: "",
        storage_location: ""
      },
      user: {
        id: 0,
        name: '',
        status: '1',
      },
      mines: [],
      users: [],
      transports: [],
      final: [],
      processes: [],
    };
  },
  components: { ArgonInput, ArgonButton },
  methods: {
    navigateTabs(direction) {
      const tabs = document.querySelectorAll('#consultationTabs .nav-link');

      if (direction === 'next' && this.activeTabIndex < tabs.length - 1) {
        this.activeTabIndex++;
      } else if (direction === 'prev' && this.activeTabIndex > 0) {
        this.activeTabIndex--;
      }

      // Activar la pestaña correspondiente
      tabs[this.activeTabIndex].click();
    },
    // Formulario pestaña 1
    async save() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("minesExtractions/save", this.extraction);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.push({ name: 'Extraction' });
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    // Formulario pestaña 2
    async getTransports() {
      const response = await this.$store.dispatch("minesExtractionsTransport/getData", this.extraction.id);
      this.transports = response.data;
    },
    async deleteTransport(id) {
      try {
        const response = await this.$store.dispatch("minesExtractionsTransport/delete", id);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El transporte ha sido eliminado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getTransports();
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al eliminar el transporte');
        }
      } catch (error) {
        console.error("Error al eliminar el transporte:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el transporte',
        });
      }
    },
    // Formulario pestaña 3
    async getFinal() {
      const response = await this.$store.dispatch("minesExtractionsFinal/getData", this.extraction.id);
      this.final = response.data;
    },
    async deleteFinal(id) {
      try {
        const response = await this.$store.dispatch("minesExtractionsFinal/delete", id);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El almacenamiento ha sido eliminado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getFinal();
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al eliminar el almacenamiento');
        }
      } catch (error) {
        console.error("Error al eliminar el almacenamiento:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el almacenamiento',
        });
      }
    },
    //Funciones de precarga
    async getMines() {
      const response = await this.$store.dispatch("mines/getAll");
      this.mines = response;
      // Si extraction.mine_id ya viene seteado antes de que lleguen las minas
      if (this.extraction.mine_id) {
        const selectedMine = this.mines.find(m => m.id == this.extraction.mine_id);
        this.extraction.extraction_location = selectedMine ? selectedMine.location : '';
      }
    },
    async getUsers() {
      const response = await this.$store.dispatch("users/getAll");
      this.users = response;
    },
  },
  watch: {
    'extraction.mine_id'(newVal) {
      // Actualiza select2
      $(this.$refs.selectMine).val(newVal).trigger('change.select2');
      // Actualiza la ubicación de la mina según la selección
      const selectedMine = this.mines.find(mine => mine.id == newVal);
      this.extraction.extraction_location = selectedMine ? selectedMine.location : '';
    }
  },
  mounted() {
    const data = this.$route.params.data;
    if (data) {
      try {
        const params = JSON.parse(data);
        this.extraction = params;
      } catch (error) {
        console.error("Error al parsear datos:", error);
      }
    }


    // 2) Cargamos usuarios (para que las <option> existan)
    this.getUsers().then(() => {
      // 3) Esperamos a que Vue pinte <select> en el DOM
      this.$nextTick(() => {
        // 4) Inicializamos select2
        $(this.$refs.selectUser).select2()
          .on("select2:select", (e) => {
            this.extraction.worker_id = e.target.value;
          });

        // 5) Si ya tienes un worker_id en extraction, forzamos a select2 a mostrarlo
        if (this.extraction.worker_id) {
          $(this.$refs.selectUser)
            .val(this.extraction.worker_id)
            .trigger('change');
        }
      });
    });

    this.getMines();
    this.getTransports();
    this.getFinal();

    // setNavPills, setTooltip, etc.
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>


<style scoped>
.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  /* Dos columnas iguales */
}
</style>